<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						贊助
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row">
					<div class="col-12 my-3">						
						對網站有任何問題請來信 , Name: Blanc , Mail: <a href="mailto:blblanc2212@gmail.com">blblanc2212@gmail.com</a>
						<br>
						如果您喜歡本站,願意為本站付出一份心力，下為抖內的連結<br>
					</div>
					<div class="col text-center">
						<a class="donate" href="https://p.ecpay.com.tw/866A5" target="_blank">
							<img src="/static/images/ecpay.png" alt="ecpay" class="img-fluid">
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
export default {
	name: 'Donors',
	data() {
		return {
			donateList: []
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '贊助',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	methods: {
		
	},
	created: function() {
		
	},
	computed: {},
	mounted: function() {}
}

</script>
<style scoped>
</style>
